"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const createFallbackOptions_1 = require("./createFallbackOptions");
exports.createOptions = (config) => {
    const isChannelOk = typeof config.channel === "string" && config.channel.length > 0;
    if (!isChannelOk) {
        throw new Error("localsync requires a channel config (string).\n\tThe channel is used to identity unique channels for pub / sub messages.");
    }
    const level = config.level
        ? config.level
        : process.env.NODE_ENV === "development"
            ? "INFO"
            : "ERROR";
    return Object.assign({}, config, { level, fallback: createFallbackOptions_1.createFallbackOptions(config.fallback) });
};
//# sourceMappingURL=createOptions.js.map